// sessionStorageのキー（callbackページと共有）
export const OAUTH_PROFILE_ID_KEY = 'oauth_profile_id';

/**
 * Gov Profile 関連の Query Key
 * 一覧・詳細・OAuth・証明書ステータスを統一管理
 */
export const govProfileKey = {
  all: ['gov-profile'] as const,
  // 一覧
  lists: () => [...govProfileKey.all, 'list'] as const,
  list: () => [...govProfileKey.lists()] as const,
  // 詳細
  details: () => [...govProfileKey.all, 'detail'] as const,
  detail: (profileId: string) => [...govProfileKey.details(), profileId] as const,
  // OAuth ステータス
  oauthStatus: (profileId: string) => [...govProfileKey.all, profileId, 'oauth-status'] as const,
  // 証明書ステータス
  certificateStatus: (profileId: string) => [...govProfileKey.all, profileId, 'certificate-status'] as const
} as const;